<script>
	import { getContext } from "svelte";

	const { xRange, yRange, yScale } = getContext("LayerCake");

	export let label;
	export let value;
	export let sublabel = "";
	export let color = "#f00";
	export let opacity = 1;
	export let preliminary;

	$: centerX = $xRange[0] + 0.5 * ($xRange[1] - $xRange[0]);
	$: centerY = $yRange[0] + 0.5 * ($yRange[1] - $yRange[0]);

	$: posX = centerX;
	$: posY = $yScale(4);
</script>

<div class="latest-value" style:left={posX + "%"} style:top={posY + "%"} style:color style:opacity>
	<div class="label">
		<span class="text">{label}</span> <span class="value">{value}</span>{#if preliminary}<span class="preliminary"
				>*</span
			>{/if}
	</div>
	<div class="sublabel">
		{sublabel}{#if preliminary}*{/if}
	</div>
</div>

<style lang="scss">
	@import "../main.scss";

	.latest-value {
		position: absolute;
		text-align: center;
		transition: opacity 0.3s ease;
	}

	.label {
		font-weight: 600;
	}

	.sublabel {
		font-size: 14px;
		line-height: 17px;
		opacity: 0.5;
	}

	.preliminary {
		display: none;
		font-weight: normal;
	}

	@media (min-width: #{$text-width + 1px}) {
		.latest-value {
			transform: translate(-50%, -50%);
		}

		.label {
			font-weight: 600;
			font-size: 18px;
			line-height: 23px;
		}
	}

	// text-width + mobile
	// @media (max-width: $raster-width) {
	// 	.sublabel {
	// 		display: none;
	// 	}

	// 	.latest-value {
	// 		top: 0px !important;
	// 	}
	// }

	// mobile
	@media (max-width: $text-width) {
		.latest-value {
			left: 50% !important;
			transform: translateX(-50%);
		}

		.label {
			font-size: 16px;
			line-height: 23px;
		}

		.value {
			font-weight: 400;
		}

		.sublabel {
			display: none;
		}

		.preliminary {
			display: inline;
		}

		.latest-value {
			top: 0px !important;
		}
	}
</style>
